import { http } from '~~core';

import { agreementsDataSchema } from '../schemas/agreement';

export async function fetchAgreements(signatureRequestKey: string, documentKey: string) {
  const data = await http(`/notarial/widget/signatures/${signatureRequestKey}/documents/${documentKey}/agreements`);

  return agreementsDataSchema.parse(data).agreements;
}
